import './footer.css'

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer>
            <div className="Footerdiv">
                <div className='topfooter'></div>
                <p className="copyright">&copy; Copyright Igor Lacerda Tomich - {currentYear}</p>
            </div>
        </footer>
    );
};
